// extracted by mini-css-extract-plugin
module.exports = {"atendimentoConsulta":"Consultar_atendimentoConsulta__1FJn0","containerPainel":"Consultar_containerPainel__2zwhM"};